<mode-format-builder-title
  [field]="field"
  [titleFormat]="titleFormat"
  [titleCheckboxLabel]="titleCheckboxLabel"
  [titleInputLabel]="titleInputLabel"
  (update)="updateTitle($event)"
>
</mode-format-builder-title>
<ng-container *ngIf="isAxis">
  <mode-format-dropdown-list
    [label]="titleLocationLabel"
    [menuItems]="titlePositionMenuItems"
    [selected]="titlePosition"
    (selectedChange)="onTitlePositionChange($event)"
  >
  </mode-format-dropdown-list>
</ng-container>
<mode-format-builder-axis-labels *ngIf="field.isBinned" [menuDisabled]="true"></mode-format-builder-axis-labels>
<mode-format-builder-rotation
  *ngIf="isAxis && chartType !== 'vegasPivotTable'"
  [angle]="labelFormat?.rotation"
  (update)="updateRotation($event)"
></mode-format-builder-rotation>
<mode-format-builder-values [field]="field" [valuesFormat]="valuesFormat" (update)="updateShowValues($event)">
</mode-format-builder-values>
<mode-format-shortcut-menu
  [field]="field"
  [format]="textFormat"
  (update)="updateDefault($event)"
></mode-format-shortcut-menu>
